<a
  *ngIf="navMini else expandedSidenavItem"
  class="flex justify-center items-center ml-1 gap-2 cursor-pointer transition-colors duration-100 minimized-sidenav-item"
  routerLink="{{url}}"
  routerLinkActive="minimized-active"
  #rla="routerLinkActive"
  matTooltip="{{label | translate}}"
  matTooltipPosition="right">
  <div class="w-6 h-6 justify-center items-center flex">
    <app-icon *ngIf="rla.isActive" class="cursor-pointer" fill="none" size="md" [stroke]="'#FAFAFA'" iconName="{{iconName}}"></app-icon>
    <app-icon *ngIf="!rla.isActive" class="cursor-pointer" fill="none" size="md" [stroke]="'#202020'" iconName="{{iconName}}"></app-icon>
  </div>
</a>

<ng-template #expandedSidenavItem>
  <a
    class="flex justify-start items-center gap-2 cursor-pointer transition-colors duration-100 sidenav-item"
    routerLink="{{url}}"
    routerLinkActive="expanded-active">
    <div class="w-6 h-6 justify-center items-center flex">
      <app-icon class="cursor-pointer" fill="none" size="md" [stroke]="'#202020'" iconName="{{iconName}}"></app-icon>
    </div>

    <div class="text-neutral-800 text-sm font-normal capitalize leading-4">
      {{label | translate}}
    </div>
  </a>
</ng-template>
